import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(VueRouter)
Vue.use(Element)
Vue.prototype.$axios = axios //全局注册，使用方法为:this.$axios
Vue.prototype.$qs = qs //全局注册，使用方法为:this.$qs
Vue.config.productionTip = false

//是否是开发环境，开发环境则使用代理
if(process.env.NODE_ENV == 'development') { //开发环境
	axios.defaults.baseURL = '/api';
} else if(process.env.NODE_ENV == 'production') { //生产环境
	//axios.defaults.baseURL = 'http://139.159.161.144/';http://www.fenzhisoft.com/
	axios.defaults.baseURL = 'http://www.1522znsj.com/';
}
console.log(process.env.NODE_ENV)

// 请求拦截器
axios.interceptors.request.use(
	config => {
		// 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
		// 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
		let access_token = localStorage.getItem("ind_access_token");
		if(access_token) {
			config.headers.access_token = access_token;
		}
		return config
	},
	error => {
		return Promise.error(error);
	})

// 响应拦截器
axios.interceptors.response.use(
	response => {
		if(response.status === 200) {
			switch(response.data.status){
				case '00':
					return Promise.resolve(response);
					break;
				case 1001:
					// 1001: token过期                
					// 未登录则跳转登录页面，并携带当前页面的路径                
					// 在登录成功后返回当前页面，这一步需要在登录页操作
					localStorage.removeItem('ind_user');
					localStorage.removeItem('ind_access_token');
					router.replace({
						path: '/',
						/*query: {
							redirect: router.currentRoute.fullPath
						}*/
					});
					break;
				default:
					return Promise.resolve(response);
			}
		} else {
			return Promise.reject(response);
		}
	},
	// 服务器状态码不是200的情况    
	error => {
		if(error.response.status) {
			switch(error.response.status) {
				// 1001: token过期                
				// 未登录则跳转登录页面，并携带当前页面的路径                
				// 在登录成功后返回当前页面，这一步需要在登录页操作。                
				case 1001:
					router.replace({
						path: '/login',
						query: {
							redirect: router.currentRoute.fullPath
						}
					});
					break;
					// 其他错误，直接抛出错误提示                
				default:
					Toast({
						message: error.response.data.message,
						duration: 1500,
						forbidClick: true
					});
			}
			return Promise.reject(error.response);
		}
	}
);
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export const postApi = (url, ...params) => {
	return new Promise((resolve, reject) => {
		axios.post(url, qs.stringify(...params))
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
};
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export const getApi = (url, ...params) => {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params[0]
			})
			.then(res => {
				if(res.data.status == '1001') {

				} else {
					resolve(res.data);
				}
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
Vue.prototype.postApi = postApi //挂载到Vue实例上面
Vue.prototype.getApi = getApi //挂载到Vue实例上面

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')